import { render } from "./index.vue?vue&type=template&id=980e3674&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=980e3674&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-980e3674"

export default script